<template>
    <div class='flex h-full bs-temp-grunt-view' style='overflow: auto'>
        <div class="flex h-full" style="flex: 0 0 500px;">
            <ai-grid-ro
                ref='gridRef'
                :meta='gridMeta'
                :showFilterPanel="false"
                :to-remove-toolbar-items-names='removeGridToolbarBtns'
                @row-click="onRowClick"
            ></ai-grid-ro>
        </div>
        <div class='h-full flex flex-col w-full'>
            <ai-grid-ro
                ref='gridRoRef'
                :meta='gridRoMeta'
                :args='gridRoArgs'
                :showFilterPanel="false"
                :to-remove-toolbar-items-names='removeGridToolbarBtns'
            ></ai-grid-ro>
        </div>
    </div>
</template>
<script>
export default {
    name: 'bs-temp-grunt-view',
};
</script>
<script setup>
import { onMounted, ref } from 'vue';
import { getCookie } from '@/utils/cookies';

const gridRef = ref(null);
const gridRoRef = ref(null);
const defaultSaveArgs = ref({kod_hgr: -1, depId: +getCookie('dep')});
const selectedNsiKod = ref(null);
const gridRoArgs = ref(null);

onMounted(async() => {
    await gridRef.value?.setDataSource();
    const dataGrid = await gridRef.value?.getGridDataSource();
    const keySelectGridFocus = dataGrid?.length ? dataGrid[0].kod : null;
    await gridRef.value?.gridInstance.option('focusedRowKey', keySelectGridFocus);
    selectedNsiKod.value = keySelectGridFocus;
    await getGridArgs(keySelectGridFocus);
});

const getGridArgs = async (key) => {
    defaultSaveArgs.value.kod_hgr = key;
    const defaultGridArgs = {
        select_args: { ...defaultSaveArgs.value },
    };
    gridRoArgs.value = { ...defaultGridArgs };
    await  setTimeout(async () =>{
        gridRoRef.value?.setDataSource();
        const dataGridRo = await gridRoRef.value?.getGridDataSource();
        const keySelectGridFocus = dataGridRo?.length ? dataGridRo[0].kod_period : null;
        await gridRoRef.value?.gridInstance.clearSelection();
        await gridRoRef.value?.gridInstance.option('focusedRowKey', keySelectGridFocus);
    }, 100);
};

const onRowClick = async (event) => {
    selectedNsiKod.value = event.key;
    if(selectedNsiKod.value !== defaultSaveArgs.value.kod_hgr) {
        await getGridArgs(selectedNsiKod.value);
    }
}

const removeGridToolbarBtns = ['choice', 'edit', 'show-column-chooser', 'searchPanel', 'copy'];
const gridMeta = {
    'keyExpr': 'kod',
    'columns': [
        {
            'name': 'kod',
            'caption': 'kod',
            'dataField': 'kod',
            'allowEditing': false,
            'width': 250,
            'index': 1,
            'visible': false,
        },
        {
            'name': 'hgr',
            'caption': 'Глубина залегания (м)',
            'dataField': 'hgr',
            'allowEditing': false,
            'dataType': 'number',
            'width': '50%',
            'index': 2,
            'visible': true,
        },
        {
            'name': 'tgr',
            'caption': 'Температура грунта (С)',
            'dataField': 'tgr',
            'allowEditing': false,
            'dataType': 'number',
            'width': '50%',
            'index': 3,
            'visible': true,
        },

    ],
    'api': {
        'select': 'tep-nsi./tep-nsi/bs-temp-grunt-grid/select/get',
        'save': 'tep-nsi./tep-nsi/bs-temp-grunt-grid/save/set',
    },
    'viewId': 'view-bs-temp-grunt-grid',
    'isFilterPanelVisible': false,
};

const gridRoMeta = {
    'keyExpr': 'kod_period',
    'columns': [
        {
            'name': 'kod_period',
            'caption': 'kod_period',
            'dataField': 'kod_period',
            'allowEditing': false,
            'width': 250,
            'index': 1,
            'visible': false,
        },
        {
            'name': 'name',
            'caption': 'Период',
            'dataField': 'name',
            'allowEditing': false,
            'width': '50%',
            'index': 2,
            'visible': true,
        },
        {
            'name': 't1_max',
            'caption': 'Температура грунта (С)',
            'dataField': 't1_max',
            'allowEditing': false,
            'width': '50%',
            'index': 3,
            'visible': true,
            'dataType': 'number',
        },
    ],
    'api': {
        'select': 'tep-nsi./tep-nsi/bs-temp-grunt-grid-ro/select/get',
    },
    'viewId': 'view-bs-temp-grunt-grid-ro',
};
</script>
<style scoped></style>
